import React, {Component} from 'react';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/fontawesome-free-solid';

import styled from 'styled-components';

class PackagePicker extends Component {


    selectPrev() {
        const {options, value, onChange} = this.props;
        const index = options.findIndex(i=>i.id === value);
        if(index > 0) {
            onChange(options[index - 1].id);
        }
    }

    selectNext() {
        const {options, value, onChange} = this.props;
        const index = options.findIndex(i=>i.id === value);
        if(index < options.length - 1) {
            onChange(options[index + 1].id);
        }
    }

    render() {
        const {className} = this.props;

        const {options, value, onChange} = this.props;
        var arrow = this.props.options.length;
        if(arrow > 1){
            return <div className={className}>
            <div className='wrapperPkg'>
                <a href="javascript:void(0)"
                onClick={e=>this.selectPrev()}
                className="carousel__arrow carousel__arrow--left">
                    <FontAwesomeIcon icon={faChevronLeft} size={'1x'}/>
                </a>
                <div className={'package-picker__option-container'}>
                    Package {options.findIndex(item=>item.id === value) + 1}
                </div>
                <a href="javascript:void(0)"
                onClick={e=>this.selectNext()}
                className="carousel__arrow carousel__arrow--right">
                    <FontAwesomeIcon icon={faChevronRight} size={'1x'}/>
                </a>
            </div>
        </div>
        } else {
            return <div className={className}>
            <div className='wrapperPkg'>
                <div className={'package-picker__option-container'}>
                    Package {options.findIndex(item=>item.id === value) + 1}
                </div>
            </div>
        </div>
        }
        
    }
}


export default styled(PackagePicker)`
  & {
    max-width: 450px;
    margin: 0px auto 20px;
    padding: 0px 12px;
    
    display: flex;
    flex-direction: row;
    color: rgba(25,25,25,0.5);
    text-transform: uppercase;
    font-size: 1rem;
    @media (max-width: 1000px){
        padding: 0px;
        margin-bottom: 18px;
    }
    
    > a {
      display: block;
      width: 24px;
      
      text-align: center;
      
    }
    .wrapperPkg {
        width: 100%;
        margin: 0 auto;
        position: relative;
    }
    .package-picker__option-container {
      text-align: center;
      flex: 1;
      padding: 15px 12px;
      margin: 0px 10px;
      @media (max-width: 1000px){
          padding: 0px;
      }
    }

     .carousel__arrow {
      color: #B2B2B2;
    }
    .carousel__arrow--left {
        position: absolute;
        top: 29%;
        left: 5%;
        @media (max-width: 1000px){
            top: 3%;
        }
    }
    .carousel__arrow--right {
        position: absolute;
        top: 29%;
        right: 5%;
        @media (max-width: 1000px){
            top: 3%;
        }
    }
    .carousel__arrow:hover {
      color: rgba(25,25,25,0.3);
    }
    .svg-inline--fa.fa-w-10 {
        width: 0.555em;
    }
    
  }
`


// WEBPACK FOOTER //
// ./src/components/configurator/PackagePicker.js